<template>
  <div class="row mx-0">
    <div class="col-1"></div>
    <div class="col-10">
      <div class="p-0 m-0 mt-4 main-title">編輯保養計畫</div>
      <div style="margin-top: 2rem">
        <div class="row">
          <commonQueryInput
            :inputItems="multiInputItems"
            v-model:getValue="multiInputVal"
          ></commonQueryInput>

          <template v-if="fileInputsShow">
            <div class="row g-3 m-0 text-start">
              <div v-for="index in 12" class="col-xl-3 col-md-4 col-sm-6">
                <div class="d-flex justify-content-between">
                  <span class="">{{ index }}月</span>
                  <span
                    v-if="yearMonthData.indexOf(index) != -1"
                    class="mes-maintain-schedule-imported"
                    >已匯入</span
                  >
                </div>
                <div class="input-group">
                  <input
                    class="form-control file-input"
                    type="file"
                    :id="'formFile' + index"
                    @change="handleFileUpload(index, $event)"
                    accept=".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/msexcel"
                  />
                </div>
              </div>
              <div class="col-12 text-end px-0">
                <button
                  type="button"
                  class="btn p-0 me-2"
                  style="
                    color: #fff;
                    background-color: #4b8c80;
                    width: 6rem;
                    height: 2rem;
                    font-size: 1.125rem;
                  "
                  @click="uploadExcel"
                >
                  確認匯入
                </button>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="col-1"></div>
  </div>
</template>

<script>
import commonQueryInput from "@/components/commonQueryInput.vue";
import commonTable from "@/components/commonTable.vue";
import { computed, provide, ref, watch } from "vue";
import store from "@/store";
export default {
  components: {
    commonQueryInput,
    commonTable,
  },
  setup() {
    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );
    const axiosMaintainFileResult = computed(
      () => store.getters["commonAxios/get_axiosMaintainFileResult"]
    );

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      axiosActionMaintainFile: async (payload) => {
        await store.dispatch("commonAxios/axiosActionMaintainFile", payload);
      },
      triggerLoadingBar: () => {
        store.dispatch("commonLoadingBar/triggerLoadingBar");
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
    };
    const currentYear = new Date().getFullYear();
    const yearOptins = ref([]);
    const selectYear = ref();
    const yearMonthData = ref([5, 8, 9]);

    const files = ref([]);
    const fileInputsShow = ref(false);

    const multiInputVal = ref();
    const multiInputItems = ref([
      {
        key: "year",
        label: "年度",
        checkEmpty: true,
        type: "select", // date/dateBetween/text/select/time/month
        checkEmpty: true,
        disableText: "-- 選擇年度 --",
        options: yearOptins,
        disableValue: currentYear,
      },
    ]); //watch 按查詢鍵回傳所有輸入框的值
    watch(
      multiInputVal,
      (newValue) => {
        selectYear.value = newValue["year"];
        queryDeviceAnnualRemittance();
      },
      { deep: true }
    );

    const maintainScheduleTableFields = ref([
      {
        key: "dep",
        label: "部門",
        thStyle: {
          "min-width": "70px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "device",
        label: "設備代號",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "deviceName",
        label: "設備名稱",
        thStyle: {
          "min-width": "120px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "systemName",
        label: "系統名稱",
        thStyle: {
          "min-width": "100px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "systemItem",
        label: "系統項次",
        thStyle: {
          "min-width": "70px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "checkItem",
        label: "檢查項目",
        thStyle: {
          "min-width": "150px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "ckeckList",
        label: "檢查內容",
        thStyle: {
          "min-width": "150px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "ckeckResult",
        label: "檢查結果",
        thStyle: {
          "min-width": "80px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "ckeck_op",
        label: "檢查人員",
        thStyle: {
          "min-width": "80px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "completeTime",
        label: "完成時間",
        thStyle: {
          "min-width": "180px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ]);
    const maintainScheduleTableItems = ref([
      {
        dep: "G5221",
        device: "LMS-13-003-1",
        deviceName: "批式保溫爐",
        systemName: "2.機構系統",
        systemItem: "02001",
        checkItem: "爐門鍊條",
        ckeckList: "鬆緊度檢查",
        ckeckResult: "",
        ckeck_op: "",
        orgCkeck_op_id: "",
        completeTime: "",
      },
      {
        dep: "G5221",
        device: "LMS-02-011",
        deviceName: "GFM RF-70精密鍛造機",
        systemName: "1.鍛造手",
        systemItem: "01001",
        checkItem: "旋轉馬達和角度馬達",
        ckeckList: "檢查皮帶鬆緊度",
        ckeckResult: "",
        ckeck_op: "",
        orgCkeck_op_id: "",
        completeTime: "",
      },
      {
        dep: "G5221",
        device: "LMS-02-011",
        deviceName: "GFM RF-70精密鍛造機",
        systemName: "1.鍛造手",
        systemItem: "01002",
        checkItem: "齒油箱",
        ckeckList: "檢查齒輪油#680的狀況(瓶上方油位)",
        ckeckResult: "",
        ckeck_op: "",
        orgCkeck_op_id: "",
        completeTime: "",
      },
    ]);

    const uploadExcel = () => {
      methods.triggerLoadingBar();
      const formData = new FormData();
      for (let i = 0; i < files.value.length; i++) {
        if (files.value[i] == null) {
          continue;
        }
        formData.append("files[]", files.value[i]);
        formData.append("month[]", i + 1);
      }
      //確認是否有資料需要上傳
      if (formData && formData.entries().next().done) {
        methods.triggerLoadingBar();
        methods.setTimeoutAlert("未有檔案上傳");
        return;
      }

      formData.append("year", selectYear.value);
      methods.axiosActionMaintainFile(formData).then(() => {
        let result = axiosMaintainFileResult.value;
        console.log(result);
        let response = result.Response;
        if (response != "ok") {
          methods.setTimeoutAlert("檔案上傳失敗");
        } else {
          methods.setTimeoutAlert("檔案匯入成功");
          //重新查詢一次資料
          queryDeviceAnnualRemittance();
        }
        methods.triggerLoadingBar();
      });
    };

    const handleFileUpload = (index, event) => {
      files.value[index - 1] = event.target.files[0];
      if (files.value[index - 1] === undefined) {
        files.value[index - 1] = null;
      }
    };

    const getYearOptins = () => {
      for (let year = currentYear + 1; year >= currentYear; year--) {
        yearOptins.value.push({
          value: year,
          text: year,
        });
      }
    };

    const queryDeviceAnnualRemittance = () => {
      fileInputsShow.value = false;
      methods.triggerLoadingBar();
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["vuePage"] = "devicemanagement";
      params["methods"] = "POST";
      params["whichFunction"] = "QueryDeviceAnnualRemittance";
      params["year"] = selectYear.value;
      methods.axiosAction(params).then(() => {
        console.log(axiosResult.value);
        let result = axiosResult.value;
        let response = result.Response;
        if (response == "ok") {
          let QueryTableData = result.QueryTableData;
          yearMonthData.value = QueryTableData;
          //查詢資料成功後顯示
          setTimeout(() => {
            fileInputsShow.value = true;
          }, 0);
        } else {
          methods.setTimeoutAlert(response);
        }
        methods.triggerLoadingBar();
      });
    };

    const commonMethods = {};

    getYearOptins();
    provide("commonMethods", commonMethods);
    return {
      multiInputVal,
      multiInputItems,
      maintainScheduleTableFields,
      maintainScheduleTableItems,
      yearMonthData,
      uploadExcel,
      handleFileUpload,
      fileInputsShow,
    };
  },
};
</script>

<style scoped>
.mes-maintain-schedule-imported {
  font-size: 14px;
  color: #008000;
  padding-top: 3px;
  padding-right: 5px;
}
</style>
